'use strict';

const addNotification = (state, { elementId, notification }) => {
  if (state.notifications.chats[elementId]) {
    state.notifications.chats = {
      ...state.notifications.chats,
      [elementId]: [...state.notifications.chats[elementId], notification]
    };
  } else {
    state.notifications.chats = {
      ...state.notifications.chats,
      [elementId]: [notification]
    };
  }
};

const removeNotificationsByType = (state, { elementId, type }) => {
  if (state.notifications.chats[elementId]) {
    const notUnreadMessages = notification => notification.type !== type;
    state.notifications.chats[elementId] = state.notifications.chats[elementId].filter(notUnreadMessages);
  }
};

const removeNotification = (state, elementId) => {
  if (state.notifications.chats[elementId]) {
    state.notifications.chats[elementId] = [];
  }
};

/** System notifications */
const addSystemNotification = (state, payload) => {
  state.notifications.system.messages = [payload, ...state.notifications.system.messages];
  state.notifications.system.unread += 1;
};

const dismissAllSystemNotifications = state => {
  state.notifications.system.messages = [];
  state.notifications.system.unread = 0;
};

const dismissSystemNotification = (state, notification) => {
  const index = state.notifications.system.messages.findIndex(
    i => `${i.id}_${i.timestamp}` === `${notification.id}_${notification.timestamp}`
  );
  if (index < 0) {
    return;
  }

  state.notifications.system.messages.splice(index, 1);
  if (state.notifications.system.unread > 0) {
    state.notifications.system.unread -= 1;
  }
};

const updateSystemNotifications = (state, payload) => {
  state.notifications.system.messages = [...payload];
};

const removeWelcomeNotification = state => {
  if (state.notifications.system && state.notifications.system.messages) {
    const index = state.notifications.system.messages.findIndex(i => i.id === 'welcome-notification');
    if (index < 0) {
      return;
    }

    state.notifications.system.messages.splice(index, 1);
    if (state.notifications.system.unread > 0) {
      state.notifications.system.unread -= 1;
    }
  }
};

const updateUnreadNotifications = (state, value) => (state.notifications.system.unread = value);

/** Callback Notifications */
const setCallbacks = (state, payload) => {
  state.notifications.callbacks = [...payload];
};

export default {
  addNotification,
  removeNotificationsByType,
  removeNotification,
  addSystemNotification,
  setCallbacks,
  dismissAllSystemNotifications,
  dismissSystemNotification,
  updateSystemNotifications,
  removeWelcomeNotification,
  updateUnreadNotifications
};
